module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("l2S4P"))).then(() => parcelRequire('hEqeo'));